<template>
  <div class="winners-2021-winner-user">
    <a
      href="https://steamcommunity.com/profiles/76561198842527594/"
      target="_blank"
      rel="noopener"
    >
      <Winners2021Stand
        :src="require('@/assets/img/winners/2021/winner.png')"
        alt="Никита Клиндухов"
        class="winners-2021-winner-user__img"
      />
    </a>
    <a
      class="winners-2021-winner-user__name orange"
      href="https://steamcommunity.com/profiles/76561198842527594/"
      target="_blank"
      rel="noopener"
      >Никита Клиндухов</a
    >
    <div class="winners-2021-winner-user__username-container">
      <span class="winners-2021-winner-user__username-label">
        Ник в игре:
      </span>
      <span class="winners-2021-winner-user__username">
        Константин?нет Вячеслав
      </span>
    </div>
  </div>
</template>

<script>
import Winners2021Stand from "./Winners2021Stand";

export default {
  name: "Winners2021WinnerUser",
  components: {
    Winners2021Stand
  }
};
</script>

<style lang="scss">
.winners-2021-winner-user {
  font-family: "Montserrat";

  max-width: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;

  padding-right: 20px;

  &__img {
    width: 336px;
    height: 288px;
    margin-bottom: 25px;

    filter: drop-shadow(0 20px 25px #141c33);

    .winners-2021-stand-img {
      background-color: #141c33;
      height: 205px;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__username-container {
    font-size: 18px;
    white-space: none;
    position: relative;
  }

  &__name {
    font-weight: 800;
    font-size: 31px;
    margin-bottom: 20px;
    position: relative;

    &:hover {
      text-decoration: underline;
    }
  }

  &__username-label {
    font-weight: 300;
  }

  &__username {
    font-weight: 700;
  }

  @include breakpoint("md-and-down") {
    padding-right: 0;
  }

  @include breakpoint("sm-and-down") {
    &__img {
      width: 300px;
      height: 250px;

      .winners-2021-stand-img {
        // width: 106px;
        height: 165px;
      }
    }
    &__name {
      font-size: 25px;
    }
  }

  @include breakpoint("xs-only") {
    &__name {
      font-size: 21px;
    }
    &__username-container {
      font-size: 14px;
    }
  }

  @media (max-width: 500px) {
    &__img {
      width: 250px;
      height: 220px;

      .winners-2021-stand-img {
        height: 145px;
      }
    }
  }

  @media (max-width: 400px) {
    &__img {
      width: 220px;
      height: 210px;

      .winners-2021-stand-img {
        height: 135px;
      }
    }
  }
}
</style>
